import { computed } from 'vue';

import { useLicenseStore } from '@/stores/licenseStore';
import { useSessionStore } from '@/stores/session';

import MainSettingsPage from '@/components/settings/MainSettingsPage';
import SubNetworksSettingsPage from '@/components/settings/SubNetworksSettingsPage';
import ProfileManagementForm from '@/components/settings/profiles/ProfileManagementForm';
import ExternalSourcesPage from '@/components/settings/ExternalSourcesPage';
import FTPNavigatorPage from '@/components/settings/FTPNavigatorPage';
import EmailAlertsSettingsPage from '@/components/settings/EmailAlertsSettingsPage';
import BrdcmSettingsPage from '@/components/settings/BrdcmSettingsPage.vue';
import AboutPage from '@/components/settings/AboutPage';
import MetricsPage from '@/components/settings/MetricsPage';

const SETTINGS_BASE_ROUTES = [
	{ value: 'main', component: MainSettingsPage },
	{ value: 'sub-networks', component: SubNetworksSettingsPage },
	{ value: 'profile-management', component: ProfileManagementForm },
	{ value: 'external-sources', component: ExternalSourcesPage },
	{ value: 'ftp-navigator', component: FTPNavigatorPage },
	{ value: 'email-alerts', component: EmailAlertsSettingsPage },
	{ value: 'brdcm', component: BrdcmSettingsPage },
	{ value: 'about', component: AboutPage },
];

const SETTINGS_DEBUG_ROUTES = [
	{ value: 'metrics', component: MetricsPage },
];

export const useSettingsRoutes = () => {
	const sessionStore = useSessionStore();
	const licenseStore = useLicenseStore();
	return computed(() => {
		let routes = SETTINGS_BASE_ROUTES.filter(route => (
			route.value !== 'brdcm' || licenseStore.allowBrdcm
		));
		if (sessionStore.debug) {
			routes.push(...SETTINGS_DEBUG_ROUTES);
		}
		return routes;
	});
};
